// components/Address/AddressHeading.js
import React from 'react';
import { useTheme } from '@mui/material';

const AddressHeading = ({
  addressValue,
  handleAddressChange,
  handleHeadingFocus,
  isReadOnly,
  condition
}) => {

  const theme = useTheme();
  const HeadingColor = theme.palette.blue[700];

  return (
    <input
      className=""
      placeholder={'یک عنوان وارد کنید'}
      style={{
        border: 'none',
        outline: 'none',
        userSelect: 'text',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        width: '100%',
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: 1.45,
        color: HeadingColor,
      }}
      readOnly={isReadOnly || condition}
      value={addressValue}
      onChange={handleAddressChange}
      onFocus={isReadOnly ? null : handleHeadingFocus}
    />
  );
};

export default AddressHeading;
